import styled from '@emotion/styled';
import { palette, radius, shadow, spacing, typography } from '../../../../style-utils/theme';
import { down } from '../../../../style-utils/media-queries';

/* The guide's photo cards (plan S7.8): the EntityGallery grid rhythm, a 4:3
   frame per slot (the guide shows wide photos), the actions under it. */

export const SlotGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: ${spacing.sm};
  margin: 0;
  padding: 0;
  list-style: none;

  ${down('sm')} {
    grid-template-columns: 1fr;
  }
`;

export const SlotCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.md};
  background: ${palette.surface};
  box-shadow: ${shadow.xs};
`;

export const Frame = styled.div`
  position: relative;
  aspect-ratio: 4 / 3;
  border-radius: ${radius.sm};
  overflow: hidden;
  background: ${palette.surfaceMuted};
`;

export const EmptyFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 4 / 3;
  border: 1px dashed ${palette.lineStrong};
  border-radius: ${radius.sm};
  background: ${palette.surfaceMuted};
  color: ${palette.slate};
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
`;

export const SlotName = styled.h3`
  margin: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
`;

export const Progress = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;
